import { gql, TypedDocumentNode } from '@apollo/client'
import type { EmployeeCertificateFragment } from './__generated__/EmployeeCertificateFragment'

export const employeeCertificateFragment: TypedDocumentNode<EmployeeCertificateFragment> = gql`
  fragment EmployeeCertificateFragment on EmployeeCertificate {
    certificateType
    expiresOn
    id
    scannedDocumentBackUrl
    scannedDocumentUrl
  }
`
